import React from "react";
import removeImg from "assets/svgs/close.svg";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import IconUpdate from "./iconUpdate";

const SlidersArray = ({ sliders, setSliders }) => {
  const handleInputOnChange = (e, id) => {
    const { name, value } = e.target;

    const newSlidersArray = sliders?.map((slider, index) => {
      if (index !== id) return slider;

      // make an object with locals inside the big one
      const inputName = name?.split(".")?.[0];
      const local = name?.split(".")?.[1];

      if (local) {
        return {
          ...slider,
          [inputName]: {
            ...slider?.[inputName],
            [local]: value,
          },
        };
      }

      return { ...slider, [name]: value };
    });

    setSliders(newSlidersArray);
  };
  const removeSlider = (sliderId) => {
    const newSliders = sliders?.filter((slider, index) => index !== sliderId);
    setSliders(() => newSliders);
  };

  const addSlider = () => {
    setSliders(() => [
      ...(sliders || []),
      {
        title: {},
      },
    ]);
  };
  return (
    <div className="form-group branches sliders">
      <Row style={{ rowGap: "10px" }}>
        <h5>
          <FormattedMessage id={"features"} />
        </h5>

        {sliders?.map((slider, index) => {
          return (
            <Row key={index}>
              <div className="add-multi-component">
                <Row style={{ rowGap: "10px" }}>
                  <button
                    type="button"
                    onClick={() => removeSlider(index)}
                    className="removeImg"
                  >
                    <img src={removeImg} alt="" />
                  </button>
                  <Row>
                    <IconUpdate
                      index={index}
                      item={slider}
                      sliders={sliders}
                      setSliders={setSliders}
                    />
                  </Row>
                  <Row>
                    <Col lg={6}>
                      <div className="form-group">
                        <h5>
                          <FormattedMessage id={"title"} /> ({" "}
                          <FormattedMessage id={"arabic-language"} /> )
                        </h5>
                        <input
                          type="title"
                          name={"title.ar"}
                          className="form-control form-outline"
                          onChange={(e) => handleInputOnChange(e, index)}
                          value={slider?.title.ar}
                        />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="form-group">
                        <h5>
                          <FormattedMessage id={"title"} /> ({" "}
                          <FormattedMessage id={"english-language"} /> )
                        </h5>
                        <input
                          type="title"
                          name={"title.en"}
                          className="form-control form-outline"
                          onChange={(e) => handleInputOnChange(e, index)}
                          value={slider?.title.en}
                        />
                      </div>
                    </Col>
                  </Row>
                </Row>
              </div>
            </Row>
          );
        })}

        <Row>
          <Col lg={4} xs={12} className="text-left">
            <button
              type="button"
              className="btn btn-green add_new_section__"
              onClick={() => {
                addSlider();
              }}
            >
              <FormattedMessage id={"addAdvantage"} />
            </button>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default SlidersArray;
